import React from 'react';

import Box, { Item as BoxItem } from 'devextreme-react/box';

import AntLocalization from '../utils/AntLocalization';

export default class extends React.Component {
    constructor(props) {
        super(props);

        this.API = this.props.API;

        this.state = {};
    }

    render() {
        var strValue = this.props.value;

        if (!strValue) strValue = 0;
        if (this.props.dataType === 'currency') strValue = AntLocalization.translateCurrency(parseFloat(strValue));
        if (this.props.dataType === 'int') strValue = AntLocalization.translateInteger(parseFloat(strValue));
        if (this.props.dataType === 'float') strValue = AntLocalization.translateDecimal(parseFloat(strValue));
        if (this.props.dataType === 'percent') strValue = (parseFloat(strValue) * 100).toFixed(1) + ' %';

        // if (this.props.value === null) strValue = '';

        return (
            <React.Fragment>
                <div className="ant-statistic-item">
                    <Box direction="col" height="100%">
                        <BoxItem ratio={1}>
                            <Box direction="row" width="100%">
                                {this.props.icon && (
                                    <BoxItem baseSize={60}>
                                        {/* <i class="dx-icon dx-icon-home"></i> */}
                                        <img style={{ width: 20 }} src={this.props.icon}></img>
                                    </BoxItem>
                                )}
                                <BoxItem ratio={1}>
                                    <span className="ant-statistic-item-value">{strValue}</span>
                                </BoxItem>
                            </Box>
                        </BoxItem>
                        {this.props.caption && (
                            <BoxItem baseSize={10}>
                                <span className="ant-statistic-item-caption">{AntLocalization.translateText(this.props.caption)}</span>
                            </BoxItem>
                        )}
                    </Box>
                </div>
            </React.Fragment>
        );
    }
}
